<template>
  <!-- <f7-page class=""> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
      <page-nav-bar
        currentServiceName="DealPrudence"
        subNavTitle="Settings"
        :menuAccess="true"
      ></page-nav-bar>
      <div class="layoutTop" />
      <div class="container-fluid">
        <div class="settingBetweenList" />
        <nav aria-label="Paramètres de configuration" class="list-block">
          <ul role="list">
            <li v-if="serviceName === 'Payments' || serviceName === ''" role="listitem">
              <a href="/settings/application/" class="item-link item-content" 
                 :aria-label="$t('settings.applctn_sttngs') + ' - ' + $t('accessibility.navigate_to_settings')">
                <div class="item-inner">
                  <div class="item-title">
                    {{ $t("settings.applctn_sttngs") }}
                  </div>
                </div>
              </a>
            </li>
            <li v-else-if="serviceName === 'Direct Debit'" role="listitem">
              <a href="/settings/directDebit/" class="item-link item-content"
                 :aria-label="$t('settings.applctn_sttngs') + ' - Direct Debit - ' + $t('accessibility.navigate_to_settings')">
                <div class="item-inner">
                  <div class="item-title">
                    {{ $t("settings.applctn_sttngs") }}
                  </div>
                </div>
              </a>
            </li>
            <li v-else-if="serviceName === 'Direct Payments'" role="listitem">
              <a
                href="/settings/directPayments/"
                class="item-link item-content"
                :aria-label="$t('settings.applctn_sttngs') + ' - Direct Payments - ' + $t('accessibility.navigate_to_settings')"
              >
                <div class="item-inner">
                  <div class="item-title">
                    {{ $t("settings.applctn_sttngs") }}
                  </div>
                </div>
              </a>
            </li>
            <li role="listitem">
              <a href="/settings/remind/" class="item-link item-content"
                 :aria-label="'Remind Settings - ' + $t('accessibility.navigate_to_settings')">
                <div class="item-inner">
                  <div class="item-title">Remind Settings</div>
                </div>
              </a>
            </li>
          </ul>
        </nav>
        <div class="toolbarPageBottomBlank"></div>
      </div>
    </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>
// import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from "@/components/common/pageNavBar.vue";
import bottomToolbar from "@/components/bottomToolbar/bottomToolbar.vue";

export default {
  components: {
    "page-nav-bar": pageNavBar,
    "bottom-toolbar": bottomToolbar,
  },
  data: () => {
    return {
      serviceName: "",
    };
  },
  created: function () {
    let that = this;
    this.$f7.params.swipePanel = that.$engine.firstOn().services.directPayments.filter
      .smartphoneStorage
      ? "left"
      : false;
    this.$f7.params.panelsCloseByOutside =
      that.$engine.firstOn().services.directPayments.filter.smartphoneStorage;
    that.serviceName = this.$engine.firstOn().user.currentService.name;
    if (!that.serviceName) {
      that.serviceName = "";
    }
  },
};
</script>
<style>
</style>
